import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { FlexColumn, Flex } from '../Flex';
import { fontSize, fontWeight, radius, space } from '../../style/utils';

const ListContainer = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.border.default};
  border-radius: ${radius('lg')};
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.surface.base};
`;

const ListItem = styled(Flex)`
  min-height: 64px;
  height: auto;
  padding: ${space('lg')};
  align-items: center;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.default};
  }
`;

const AddSection = styled(FlexColumn)`
  cursor: pointer;
  font-weight: ${fontWeight('semibold')};
  text-decoration: underline;
  font-size: ${fontSize('base')};
  color: ${({ theme }) => theme.palette.content.primary};
  border-top: 1px solid ${({ theme }) => theme.palette.border.default};
  transition: background-color 0.2s;
  padding: ${space('lg')};
  &:hover {
    background-color: ${({ theme }) => theme.palette.surface.sunken};
  }
`;

type AddableListProps = {
  children: ReactNode;
  onAdd: () => void;
  addButtonText: string;
  showAddButton?: boolean;
};

const AddableList = ({
  children,
  onAdd,
  addButtonText,
  showAddButton = true,
}: AddableListProps) => (
  <ListContainer>
    <FlexColumn>{children}</FlexColumn>
    {showAddButton && <AddSection onClick={onAdd}>{addButtonText}</AddSection>}
  </ListContainer>
);

export { AddableList, ListItem };
